

<!-- メイン -->
<div class="main" *ngIf="isDataLoaded">
  <!-- メインコンテンツ -->
  <div class="main-content">
    <!-- 戻る -->
    <div class="return">
      <button
        pButton
        type="button"
        label="一覧へ戻る"
        icon="pi pi-angle-left"
        class="p-button-text"
        (click)="moveC241()"
      ></button>
    </div>
    <div class="p-fluid p-formgrid p-grid screen-support">
      <div class="p-col-9 content">
        <div class="p-fluid p-formgrid p-grid support-header">
          <div class="p-col-12">
            <p-card class="support-header-card">
              <div class="support-header-card-show">
                <div class="p-fluid p-formgrid p-grid teacher-content">
                  <div class="p-col-2 image">
                    <div class="support-header-card-detail-img"
                      [ngStyle]="{
                        'background-image':
                          'url(' + detailTask?.icon_image + ')'
                      }"></div>
                  </div>
                  <div class="p-col-10 support-desc">
                    <div class="box-content">
                      <span
                        class="tittle-teacher text-black-color"
                        [ngClass]="setClassSubId(detailTask?.class_sub_id)"
                        >{{ detailTask?.class_sub_id }}
                      </span>
                      <span class="title-header  primary-title p-text-bold" pTooltip="{{ detailTask?.municipalities + ' ' + detailTask?.organization_name }}">
                        {{ detailTask?.municipalities + " " + detailTask?.organization_name }}
                      </span>
                      <div class="elementary-school">
                        <span pTooltip="{{ detailTask?.oneword_message }}">
                          {{ detailTask?.oneword_message }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </p-card>
          </div>

          <div class="p-col-12">
            <span class="p-text-bold">団体情報</span>
          </div>

          <div class="p-col-12">
            <div class="support-separate"></div>
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-first">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">団体区分詳細</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.class_sub_id }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-third">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">団体名</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.organization_name }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-second">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview no-wrap"
                      >所在地(市区町村)
                    </span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.municipalities }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-fourth">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview no-wrap"
                      >所在地<br>&nbsp;(それ以降の住所)</span
                    >
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.address_building }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-fourth">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview no-wrap"
                      >電話番号</span
                    >
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.tel }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-sixth">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-sub">※各団体へのお問い合わせは、<br>急ぎの場合を除き、原則、本<br>システム内のチャットでお願<br>いします。</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <div class="sperate-header"></div>
          </div>

          <div class="p-col-12">
            <span class="p-text-bold">希望内容</span>
          </div>

          <div class="p-col-12">
            <div class="support-separate"></div>
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-fourth">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview no-wrap"
                      >参加乳幼児の年齢</span
                    >
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.target_grade }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-fourth">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview no-wrap"
                      >参加乳幼児数</span
                    >
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.desired_people_number }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-fourth">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview no-wrap"
                      >希望時期・日数</span
                    >
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.desired_datetime }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-fourth">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview no-wrap"
                      >実施場所</span
                    >
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.desired_location }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-fourth">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview no-wrap"
                      >園・施設で受け入れる<br>場合に、一度に対応可<br>能な生徒数の規模</span
                    >
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.expected_people_number }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-fourth">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview no-wrap"
                      >実施可能曜日</span
                    >
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.desired_dayweek }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-fourth">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview no-wrap"
                      >実施希望時間</span
                    >
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.desired_time }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-fourth">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview no-wrap"
                      >希望の詳細</span
                    >
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.desired_content }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-fourth">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview no-wrap"
                      >その他、補足事項</span
                    >
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.remark }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-fourth">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview no-wrap"
                      >担当者氏名</span
                    >
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.manager_name }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <ng-container *ngIf="class_id === '1'">
              <div class="p-d-flex p-jc-center">
                <div class="p-col-3 btn-review">
                  <button
                    pButton
                    pRipple
                    type="button"
                    label="マッチング依頼"
                    class="btn-move"
                    (click)="moveC441()"
                  ></button>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
